import SMTable from './SMTable';
export default SMTable;